import PullToRefresh from '@/components/PullToRefresh.vue';

export default {
  install: (app) => {
    // Registrar el componente globalmente
    app.component('PullToRefresh', PullToRefresh);
    
    // Agregar una directiva personalizada para facilitar el uso
    app.directive('pull-to-refresh', {
      mounted(el, binding) {
        const { onRefresh, threshold = 80, resistance = 2.5 } = binding.value || {};
        
        // Si no se proporciona onRefresh, se usará window.location.reload() por defecto
        const refreshFunction = onRefresh || (() => window.location.reload());
        
        // Crear una instancia del componente PullToRefresh
        const pullToRefreshInstance = app.createApp({
          template: `
            <PullToRefresh 
              :on-refresh="refreshFunction" 
              :threshold="${threshold}" 
              :resistance="${resistance}"
            >
              <div class="pull-to-refresh-wrapper">
                <slot></slot>
              </div>
            </PullToRefresh>
          `,
          components: { PullToRefresh },
          setup() {
            return { refreshFunction };
          }
        });
        
        // Montar el componente
        const mountPoint = document.createElement('div');
        el.parentNode.insertBefore(mountPoint, el);
        mountPoint.appendChild(el);
        
        const instance = pullToRefreshInstance.mount(mountPoint);
        
        // Guardar referencia para limpieza
        el._pullToRefreshInstance = instance;
        el._pullToRefreshApp = pullToRefreshInstance;
      },
      
      unmounted(el) {
        // Limpiar instancia
        if (el._pullToRefreshApp) {
          el._pullToRefreshApp.unmount();
        }
      }
    });
  }
}; 